import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { ClaimItemComponent } from './claim-item.component';

@NgModule({
    imports: [CommonModule, PipesModule],
    exports: [ClaimItemComponent],
    declarations: [ClaimItemComponent],
})
export class ClaimItemModule { }
